export const HOME = {
        archiveGrid: "home-archive-grid",
        heroCta: "home-hero-cta",
        searchInput: "home-search-input",
        sortToggle: "home-sort-toggle",
};
